<template>

	<section class="container">

		<header class="stepper">

			<section class="stepper__wrap">

				<router-link tag="section" class="item--sm" :to="{name:'product.index'}">

					<i class="fas fa-times dark-grey"></i>

				</router-link>

				<template>

					<router-link tag="section" class="item--md" active-class="item--active" :to="{name:'product.create.product'}" v-if="isCreating">

						<section class="icon">

							<i class="fas fa-shopping-bag"></i>

						</section>

						<section class="content">

							<h1>Produkt</h1>

							<p>Påbegyndt</p>

						</section>

					</router-link>

					<router-link tag="section" class="item--md" active-class="item--active" :to="{name:'product.edit.product', params:{product:this.$route.params.product}}" v-else>

						<section class="icon">

							<i class="fas fa-shopping-bag"></i>

						</section>

						<section class="content">

							<h1>Produkt</h1>

							<p>Klar</p>

						</section>

					</router-link>

				</template>

				<template>

					<router-link tag="section" class="item--md" active-class="item--active" :to="{name:'product.edit.options', params:{product:this.$route.params.product}}" v-if="!isCreating">

						<section class="icon">

							<i class="fas fa-utensils"></i>

						</section>

						<section class="content">

							<h1>Tilvalg</h1>

							<p>Påbegyndt</p>

						</section>

					</router-link>

					<section class="item--md item--disabled" v-else>

						<section class="icon">

							<i class="fas fa-utensils"></i>

						</section>

						<section class="content">

							<h1>Tilvalg</h1>

							<p>Påbegyndt</p>

						</section>

					</section>

				</template>

				<template>
					<router-link tag="section" class="item--md" active-class="item--active" :to="{name:'product.edit.extra', params:{product:this.$route.params.product}}" v-if="!isCreating">

						<section class="icon">

							<i class="fas fa-tag"></i>

						</section>

						<section class="content">

							<h1>Tilkøb</h1>

							<p>Påbegyndt</p>

						</section>

					</router-link>

					<section class="item--md item--disabled" v-else>

						<section class="icon">

							<i class="fas fa-tag"></i>

						</section>

						<section class="content">

							<h1>Tilkøb</h1>

							<p>Påbegyndt</p>

						</section>

					</section>
				</template>

				<template>
					<router-link tag="section" active-class="item--active"  class="item--md" :to="{name:'product.edit.approve', params:{course:this.$route.params.product}}" v-if="!isCreating && selectionsValidated">

						<section class="icon">

							<i class="fas fa-thumbs-up"></i>

						</section>

						<section class="content">

							<h1>Godkend</h1>

							<p>Påbegyndt</p>

						</section>

					</router-link>
					<section class="item--md item--disabled" v-else>

						<section class="icon">

							<i class="fas fa-thumbs-up"></i>

						</section>

						<section class="content">

							<h1>Godkend</h1>

							<p>Påbegyndt</p>

						</section>

					</section>
				</template>


			</section>

		</header>

		<transition name="fade" mode="out-in">
			<router-view @refreshSelections="getSelections"></router-view>
		</transition>


	</section>

</template>

<script>
	import {mapGetters} from 'vuex';
    export default {
        name: "stepper",
		data(){
            return {
				selections:[],
			};
		},
		computed:{
			isCreating(){
			    return this.$route.params.product == null;
			},
			...mapGetters([
			    'product',
			]),
			selectionsValidated(){
			    if(this.product){
                    let isValid = true;

                    this.selections.forEach(item => {
                        if(item.options.length < item.min_options){
                            isValid = false;
                        }
                    });
                    return isValid;
				}
				return false;
			},
		},
        watch:{
            product(value){
                if(value !== null){
                    this.getSelections();
                }
            }
        },
		methods:{
            getSelections(){
                axios.get(`/api/admin/product/${this.product.id}/selection`).then(response => {
                    this.selections = response.data.data;
                    this.originalSelections = response.data.data;
                });
            },
            backToIndex(){
				this.$router.push({
					name:'product.index',
				})
			},
		},
        beforeRouteEnter(to, from, next){
            next(vm=>{
                if(!vm.isCreating){
                    axios.put(`/api/admin/product/${vm.$route.params.product}/deactivate`).then(response=>{});

                    if(!vm.isCreating){
                        vm.$store.dispatch('getProduct', vm.$route.params.product);
                    }
                }
            })
        },
    }
</script>
